import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'
import '@fontsource/inter/700.css'
import '@fontsource/jetbrains-mono/400.css'
import '@fontsource/jetbrains-mono/500.css'
import '@fontsource/jetbrains-mono/600.css'
import '@fontsource/space-grotesk/400.css'
import '@fontsource/space-grotesk/500.css'
import '@fontsource/space-grotesk/600.css'
import '@fontsource/space-grotesk/700.css'
import '@fontsource/space-mono/400.css'
import '@fontsource/space-mono/700.css'

import { TamaguiProvider, Theme } from 'tamagui'
import { createRoot } from 'react-dom/client'
import config from '@repo/configs/tamagui.config'
import { ThemeProvider, useThemeController } from '@repo/configs/themeController'
import { App } from './App'

function ThemedApp() {
  const { resolvedTheme } = useThemeController()

  return (
    <TamaguiProvider config={config}>
      <Theme name={resolvedTheme}>
        <App />
      </Theme>
    </TamaguiProvider>
  )
}

function Root() {
  return (
    <ThemeProvider>
      <ThemedApp />
    </ThemeProvider>
  )
}

const root = createRoot(document.getElementById('root')!)
root.render(<Root />)
